export interface SettingsNavItem {
  title: string;
  icon?: string;
  href: string;
  id: string;
  /** Renders the AI vendor marks in place of the lucide icon, so the row stands out. */
  brandMarks?: boolean;
}

export const settingsNavItems: SettingsNavItem[] = [
  {
    title: "Profile",
    icon: "UserIcon",
    href: "/p/settings/profile",
    id: "profile",
  },
  {
    title: "Users",
    icon: "UsersIcon",
    href: "/p/settings/users",
    id: "users",
  },
  {
    title: "API Keys",
    icon: "KeyIcon",
    href: "/p/settings/api-keys",
    id: "api-keys",
  },
  {
    title: "Connect Pylo",
    icon: "PlugIcon",
    href: "/p/settings/connected-apps",
    id: "connected-apps",
    brandMarks: true,
  },
  {
    title: "Webhooks",
    icon: "ZapIcon",
    href: "/p/settings/webhooks",
    id: "webhooks",
  },
  {
    title: "Permissions",
    icon: "KeyIcon",
    href: "/p/settings/permissions",
    id: "permissions",
  },
  {
    title: "Entity management",
    icon: "WrenchIcon",
    href: "/p/settings/entities",
    id: "entities",
  },
  {
    title: "Entity organization",
    icon: "FolderTreeIcon",
    href: "/p/settings/entity-organization",
    id: "entity-organization",
  },
  {
    title: "Environments",
    icon: "FileIcon",
    href: "/p/settings/environments",
    id: "environments",
  },
  {
    title: "Rate limits",
    icon: "GaugeIcon",
    href: "/p/settings/rate-limits",
    id: "rate-limits",
  },
  {
    title: "Features",
    icon: "SparklesIcon",
    href: "/p/settings/feature-management",
    id: "features",
  },
  {
    title: "Document templates",
    icon: "FileTextIcon",
    href: "/p/settings/document-templates",
    id: "document-templates",
  },
  {
    title: "Apps",
    icon: "AppWindow",
    href: "/p/settings/apps",
    id: "apps",
  },
  // Hidden from the sidebar while still in development. The page is still
  // reachable via the direct URL /p/settings/usage.
  // {
  //   title: "Usage",
  //   icon: "GaugeIcon",
  //   href: "/p/settings/usage",
  //   id: "usage",
  // },
  {
    title: "System",
    icon: "CogIcon",
    href: "/p/settings/system",
    id: "system",
  },
];
